// src/components/SynergyLogo.js
import React from 'react';

export default function SynergyLogo({ size = 32 }) {
  return (
    <svg width={size} height={size * 1.2} viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="synBlueGrad" x1="25" y1="0" x2="25" y2="28" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#00AAFF" />
          <stop offset="100%" stopColor="#0055DD" />
        </linearGradient>
      </defs>
      {/* Top bracket "]" — bright blue, forms top of S */}
      <path
        d="M14,0 L36,0 L36,28 L14,28 L14,22 L24,22 L28,18 L28,10 L24,6 L14,6 Z"
        fill="url(#synBlueGrad)"
      />
      {/* Bottom bracket "[" — silver/navy, forms bottom of S */}
      <path
        d="M4,20 L26,20 L26,26 L16,26 L12,30 L12,38 L16,42 L26,42 L26,48 L4,48 Z"
        fill="#9EAAB8"
      />
    </svg>
  );
}
